import { useEffect, useState } from "react";
import { SketchPicker } from 'react-color';
import {Formik} from "formik";
import {Button, Form, Modal} from "react-bootstrap";
import AccountTag from "../../model/AccountTag";
import { FormattedMessage } from "react-intl";
import TagsApi from "../../api/TagsApi";
import { updateAccountTagsStore } from "../../../../store/functions";


type Props = {
    tagId?: number|null,
}

const TagForm = ({tagId}: Props) => {
    const [tag, setTag] = useState<AccountTag>(new AccountTag(undefined, "", "#FFFFFF"));
    const [showModal, setShowModal] = useState<boolean>(false);

    const loadTagData = (tagId:number) => {
        if (tagId !== undefined) {
            TagsApi.getAccountTag(tagId)
                .then(data => {
                    setTag(data);
                })
        } 
    }

    useEffect(()=>{
        if (tagId) {
            setShowModal(true);
            loadTagData(tagId);
        } else {
            setShowModal(false);
        }       
    }, [tagId])

    const onSaveTag = (accountTag:AccountTag) => {
        updateAccountTagsStore()
    }

    const saveTag = (values:AccountTag) => {
        if (values.tagId) {
            return updateTag(values);
        } else {
            return createTag(values);
        }
    }

    const createTag = (data: AccountTag) => {
        return TagsApi.createAccountTag(data)
            .then((newAccountTag) => {
                if (onSaveTag !== undefined) {
                    onSaveTag(newAccountTag);
                }
            })
    }

    const updateTag = (data:AccountTag) => {
        return TagsApi.updateAccountTag(data)
            .then((savedTag) => {
                if (onSaveTag !== undefined) {
                    onSaveTag(savedTag);
                }
            })
    } 

    const onSubmitForm = (values: AccountTag, { setSubmitting, resetForm, setErrors }:any) => {
        saveTag(values)
        .then(() => {
            setShowModal(false)
            resetForm();
        })
        .catch((error) => {
            let respponseErrors = error.response.data.errors
            let fields = Object.keys(values);
            let fieldsErrors:any = {};
            fields.forEach(field => {
                if (field in respponseErrors) {
                    fieldsErrors[field] = respponseErrors[field];
                    
                } else {
                    fieldsErrors[field] = "";
                }
            })
            setErrors(fieldsErrors)
        })
        .finally(() => {
            setSubmitting(false);
        })
    }

    const FormModal = () => {
        return (
            <>
              <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    <FormattedMessage id="create_tag"/>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TheForm/>
                </Modal.Body>
              </Modal>
            </>
          );
    }

    const TheForm = () => {
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={tag}
                validate={values => {
                    let errors = {
                        name: "",
                        color: ""
                    };
                    let valid = true; 
                    if (!values.name) {
                        errors.name = 'Required';
                        valid = false;
                    }
                    if (!values.color) {
                        errors.color = 'Required';
                        valid = false;
                    }      
                    return valid ? {} : errors;
                }}
                onSubmit={onSubmitForm}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue                      
                      /* and other goodies */
                  }) => {
                    return (
                        <Form onSubmit={handleSubmit} noValidate={true}>
                            <Form.Group controlId="name">
                                <Form.Control type="text" placeholder="Name"
                                              name="name"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.name}/>
                                {errors.name && touched.name && <Form.Text className="text-danger">
                                    {errors.name}
                                </Form.Text>}
                            </Form.Group>

                            <Form.Group controlId="color">
                                <SketchPicker 
                                    color={values.color}
                                    onChange={(color: any, event: any) => {
                                        setFieldValue("color", color.hex)
                                    }}/>
                                {errors.color && touched.color && <Form.Text className="text-danger">
                                    {errors.color}
                                </Form.Text>}

                                
                            </Form.Group>

                            <Button variant="primary" type="submit" disabled={isSubmitting} className="btn-color">
                                <FormattedMessage id="save"/>
                            </Button>
                        </Form>
                    )
                  }}
            </Formik>
        </>
    )};

    return (
        <>
            <Button variant="primary" onClick={(e) => setShowModal(true)} className="btn btn-color btn-sm">+</Button>
            <FormModal/>
        </>
        )
}

export default TagForm;